import { createAction } from '@reduxjs/toolkit';

const changeSocketState = createAction<string>('SOCKET_STATE/CHANGE_STATE');

export default changeSocketState;
